<template>
  <div id="conexaoCaixaVinculoAtivo">
    <div class="row items-center">
      <div class="col">
        <div class="row items-center">
          <q-icon
            name="fiber_manual_record"
            :color="agenteOnline ? 'green' : 'grey-6'"
            size="12px"
            class="q-mr-sm"
          />
          <span class="text-body2">{{ agenteOnline ? 'Ativa' : 'Indisponível' }}</span>
        </div>
        <div v-if="perfil" class="text-caption text-grey-7 q-mt-xs">{{ perfil }}</div>
        <div v-if="!agenteOnline" class="text-caption text-grey-7 q-mt-xs">
          Verifique se o computador da lotérica está ligado.
        </div>
      </div>

      <div class="col-auto">
        <q-btn flat dense round icon="more_vert" color="grey-7">
          <q-menu>
            <q-list dense style="min-width: 180px">
              <q-item clickable v-close-popup @click="dialogCompartilhar = true">
                <q-item-section>Conectar outra empresa</q-item-section>
              </q-item>
              <q-item clickable v-close-popup :disable="desconectando" @click="dialogDesconectar = true">
                <q-item-section class="text-negative">Desconectar</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </div>
    </div>

    <ConexaoCaixaCompartilharDialog v-model="dialogCompartilhar" />

    <q-dialog v-model="dialogDesconectar" persistent>
      <q-card style="min-width: 320px; max-width: 420px">
        <q-card-section>
          <div class="text-subtitle1">Desconectar</div>
          <div class="text-body2 q-mt-sm">
            Esta empresa deixa de usar a integração até ser configurada de novo.
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat no-caps label="Cancelar" color="grey-8" :disable="desconectando" @click="dialogDesconectar = false" />
          <q-btn
            no-caps
            label="Desconectar"
            color="negative"
            :loading="desconectando"
            :disable="desconectando"
            @click="confirmarDesconectar"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConexaoCaixaCompartilharDialog from "@/components/ConexaoCaixa/ConexaoCaixaCompartilharDialog.vue";

export default {
  name: "ConexaoCaixaVinculoAtivo",

  emits: ["atualizado"],

  components: { ConexaoCaixaCompartilharDialog },

  data() {
    return {
      dialogCompartilhar: false,
      dialogDesconectar: false,
    };
  },

  computed: {
    ...mapGetters([
      "conexaoCaixaPerfilAtivo",
      "conexaoCaixaAgenteOnline",
      "conexaoCaixaVinculoLoading",
    ]),

    perfil()        { return this.conexaoCaixaPerfilAtivo; },
    agenteOnline()  { return this.conexaoCaixaAgenteOnline; },
    desconectando() { return this.conexaoCaixaVinculoLoading; },
  },

  methods: {
    ...mapActions(["desconectarConexaoCaixa"]),

    async confirmarDesconectar() {
      const res = await this.desconectarConexaoCaixa();
      this.dialogDesconectar = false;

      if (!res.ok) {
        this.$q.notify({ message: res.erro.mensagem, color: "red", position: "top-right" });
        return;
      }

      this.$q.notify({
        message: "Integração desconectada.",
        color: "orange",
        position: "top-right",
      });
      this.$emit("atualizado");
    },
  },
};
</script>
